import { ROUTES } from "../../../module/constants";
import { generalConst } from "../../../module/globalInterface";

export interface IBusinessRolesManagementProps {
  resetState: () => {};
}

export const BR_MANAGEMENT_URLS: generalConst = {
  BASE_URL: ROUTES.BR_MANAGEMENT,
  BR_CHOICE: `${ROUTES.BR_MANAGEMENT}/second-step`,
  CREATE_BR_STEP_ONE: `${ROUTES.BR_MANAGEMENT}/create-br`,
  CREATE_BR_STEP_TWO: `${ROUTES.BR_MANAGEMENT}/create-br/step-two`,
  CREATE_BR_SUMMARY: `${ROUTES.BR_MANAGEMENT}/create-br/summary`,
  MODIFY_BR_STEP_ONE: `${ROUTES.BR_MANAGEMENT}/modify-br`,
  MODIFY_BR_STEP_TWO: `${ROUTES.BR_MANAGEMENT}/modify-br/step-two`,
  MODIFY_BR_SUMMARY: `${ROUTES.BR_MANAGEMENT}/modify-br/summary`,
};

export const STATE_IDENTIFIER = {
  SELECTED_OFFICE: "selectedOffice",
  SELECTED_BR: "selectedBR",
  SELECTED_BR_ENTITLEMENTS: "selectedBrEntitlements",
  STEP_ONE: "stepOne",
  OFFICES: "offices",
  STEP_TWO: "stepTwo",
  BUSINESS_ROLES: "businessRoles",
  BR: "br",
  NAME: "name",
  DESCRIPTION: "description",
  ENTITLEMENTS: "entitlements",
  CHAIN_ENTITLEMENTS: "chainEntitlements",
  REQUEST_STATE: "requestState",
  SOD_CONFLICTS_BR: "sodConflictsBR",
};

export const LIST_IDENTIFIER: string = "list";
export const LOADER_IDENTIFIER: string = "loader";
